import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PatternService {

  alpha = /^[a-zA-Z]*$/;
  alphaWithSpace = /^[a-zA-Z ]*$/;
  numeric  = "^[0-9]+$";
  alphaNumericWithSpecial = /^[A-z \d_@.#$=!%^)(\]:\*;\?\/\,}{'\|\~\"<>\[&\+-]*$/;
  alphaNumeric = /^[a-z A-Z0-9]*$/;
  
  decimal = /^[0-9]+(\.[0-9]{0,2})?$/;
  email = /^([A-Za-z\d\.\-\_]+)@([A-Za-z\d-_.]+)\.([A-Za-z]{2,8})(\.[A-Za-z]{2,8})?$/;
  mobileNo = "^[0-9]+$";
  alphaNumericOnly = /^[a-zA-Z0-9]*$/;
  alphaNumericWithHyphenOnly = /^[a-zA-Z0-9-]*$/;
  challanNo  = /^[a-zA-Z0-9-,/]*$/;
  alphaNumericWithHyphenAndDotOnly = /^[a-zA-Z0-9-.]*$/;  
  alphaNumericWithDotCommaHyphenOnly = /^[a-zA-Z 0-9.,-]*$/;
  alphaNumericWithSlashBackslashUnderscoreHyphenOnly = /^[a-zA-Z 0-9\_/\\-]*$/;
  panNo = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
  decimal18 = /^[\d]{1,18}(\.[\d]{1,2})?$/
  constructor() {
  }

}
